import script from "./HeaderProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderProfile.vue?vue&type=script&setup=true&lang=js"

import "./HeaderProfile.vue?vue&type=style&index=0&id=54cfddb6&lang=scss"

const __exports__ = script;

export default __exports__